import { useEffect, useRef } from 'react';

export default function HeroSection() {
  const titleRef = useRef<HTMLHeadingElement>(null);
  const subtitleRef = useRef<HTMLParagraphElement>(null);
  const tagRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const elements = [tagRef.current, titleRef.current, subtitleRef.current];
    elements.forEach((el, i) => {
      if (el) {
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        setTimeout(() => {
          el.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        }, 200 + i * 180);
      }
    });
  }, []);

  return (
    <section id="home" className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/1285e893104eec7443d0dcd35b031b52.jpg"
          alt="BORVIL OOD technology background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-zinc-950/70 via-zinc-950/55 to-zinc-950/80"></div>
      </div>

      <div className="relative z-10 w-full text-center px-6 flex flex-col items-center justify-center">
        <div ref={tagRef} className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full px-5 py-2 mb-8">
          <span className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse inline-block"></span>
          <span className="text-emerald-400 text-xs font-medium tracking-widest uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>iOS Development Experts</span>
        </div>

        <h1
          ref={titleRef}
          className="text-white font-bold leading-none tracking-wide mb-6"
          style={{
            fontFamily: "'Space Grotesk', sans-serif",
            fontSize: 'clamp(3rem, 7vw, 7rem)',
            letterSpacing: '-0.02em',
          }}
        >
          BORVIL OOD
        </h1>

        <p
          ref={subtitleRef}
          className="text-zinc-300 max-w-2xl mx-auto leading-relaxed"
          style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: 'clamp(1rem, 2vw, 1.25rem)',
          }}
        >
          A team of experts engineering modern iOS applications that elevate user experience
          and strengthen mobile security for millions of users worldwide.
        </p>

        <div className="mt-16 flex items-center justify-center gap-3 text-zinc-500">
          <span className="text-xs tracking-widest uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>Discover more</span>
          <i className="ri-arrow-down-line text-emerald-400 animate-bounce text-lg"></i>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-zinc-950 to-transparent"></div>
    </section>
  );
}
